module.exports = __webpack_public_path__ + "img/petdog1.977b9975.jpg";